import { TableCell, TableRow } from "@mui/material";
import React, { useContext } from "react";
import { DropLi, formatDate, useFormatPrice } from "hooks";
import { AppContext } from "App";

const CashMovement = ({ txns = [], cashReceived = 0 }) => {
  const formatPrice = useFormatPrice();
  const { TxnTypes } = DropLi();
  const { settings } = useContext(AppContext);

  return (
    <>
      {/* Header */}
      <TableRow className="border-left bg-slate-50">
        <TableCell className="border-none !p-[10px]">
          <span className="text-[16px] primary-color font-medium ">
            Cash Movements
          </span>
        </TableCell>
        <TableCell className="!p-[10px]">
          <div className="flex gap-5 justify-between font-semibold text-gray-500">
            <div className="flex gap-7 ">
              <span className="min-w-[80px]">Time</span>
              <span>User</span>
            </div>

            <span>Amount ({settings?.currSymbol})</span>
          </div>
        </TableCell>
        <TableCell className="!p-[10px]">
          <span className="font-semibold text-gray-500">Reason</span>
        </TableCell>
        <TableCell className="!p-[10px]"></TableCell>
      </TableRow>

      {/* Cash Movements */}
      {txns &&
        txns.map((txn, ind) => {
          var txnType = TxnTypes.find((j) => j.id === txn.txnType);
          var reason = txnType ? txnType.label : "";
          return (
            <TableRow key={ind} className="border-left bg-slate-50">
              <TableCell className="border-none !p-[10px]"></TableCell>
              <TableCell className="!p-[10px]">
                <div className="flex gap-5 justify-between text-gray-500">
                  <div className="flex gap-7">
                    <span className="min-w-[80px]">
                      {formatDate(txn.txnDate)}
                    </span>
                    <span>{txn?.user?.fullName}</span>
                  </div>

                  <span
                    className={`font-medium ${
                      txn.amount > 0 ? "text-green-500" : "text-red-500"
                    }`}
                  >
                    {formatPrice(txn.amount)}
                  </span>
                </div>
              </TableCell>
              <TableCell className="!p-[10px]">
                <div className="grid max-w-[250px]">
                  <span className=" text-gray-500 font-medium">{reason}</span>
                  <span className="text-[12px] primary-color">{txn.note}</span>
                </div>
              </TableCell>
              <TableCell className="!p-[10px]"></TableCell>
            </TableRow>
          );
        })}

      {/* Cash Payment Received */}
      <TableRow className="border-left bg-slate-50">
        <TableCell className="border-t !p-[10px]">
          <span className="text-[16px] primary-color font-medium ">
            Cash Payment Received
          </span>
        </TableCell>
        <TableCell align="right" className="!p-[10px]">
          <span className="text-[18px] text-gray-500">
            {formatPrice(cashReceived)}
          </span>
        </TableCell>
        <TableCell className="!p-[10px]"></TableCell>
        <TableCell className="!p-[10px]"></TableCell>
      </TableRow>
    </>
  );
};

export default CashMovement;
